import { __assign } from "tslib";
import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import ErrorBoundary from '../ErrorBoundary';
import retry from '../utils/webpack/chunkRetry';
var LoadableRedux = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "deviationsubmitpopup" */
        './redux/ModuleLoadable');
    });
});
var LoadableDeviationSubmitPopup = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "deviationsubmitpopup" */
        './DeviationSubmitPopup');
    });
});
var LazyDeviationSubmitPopup = function (props) { return (React.createElement(ErrorBoundary, { debugComponent: "LazyDeviationSubmitPopup" },
    React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, { view: 'llama', withOverlay: true, usePortal: true }) },
        React.createElement(LoadableRedux, null),
        React.createElement(LoadableDeviationSubmitPopup, __assign({}, props))))); };
LazyDeviationSubmitPopup.displayName = 'LazyDeviationSubmitPopup';
export default LazyDeviationSubmitPopup;
//# sourceMappingURL=LazyDeviationSubmitPopup.js.map